/* eslint-disable @typescript-eslint/naming-convention */
import type { DefaultLocaleInfo } from "@vuepress/helper";

import type { VidstackLocaleData } from "../../shared/index.js";

export const vidstackLocaleInfo: DefaultLocaleInfo<VidstackLocaleData> = [
  [["en", "en-US"], {}],
  [
    ["zh", "zh-CN", "zh-Hans"],
    {
      Play: "播放",
      Pause: "暂停",
      "Enter Fullscreen": "进入全屏",
      "Exit Fullscreen": "退出全屏",
      "Enter PiP": "进入画中画",
      "Exit PiP": "退出画中画",
      "Closed-Captions On": "开启字幕",
      "Closed-Captions Off": "关闭字幕",
      Mute: "静音",
      Volume: "音量",
      "Seek Forward": "快进",
      "Seek Backward": "快退",
      Announcements: "公告",
      Accessibility: "无障碍",
      Audio: "音频",
      Auto: "自动",
      Boost: "增强",
      Captions: "字幕",
      "Caption Styles": "字幕样式",
      "Captions look like this": "字幕样式",
      Chapters: "章节",
      Connected: "已连接",
      Continue: "继续",
      Connecting: "连接中",
      Default: "默认",
      Disabled: "已禁用",
      Disconnected: "已断开连接",
      "Display Background": "显示背景",
      Download: "下载",
      Font: "字体",
      Family: "字体",
      Fullscreen: "全屏",
      "Keyboard Animations": "键盘动画",
      LIVE: "直播",
      Loop: "循环",
      Normal: "正常",
      Off: "关闭",
      Playback: "播放",
      PiP: "画中画",
      Quality: "画质",
      Replay: "重播",
      Reset: "重置",
      Seek: "搜索",
      Settings: "设置",
      "Skip To Live": "跳转到直播",
      Speed: "速度",
      Size: "大小",
      Color: "颜色",
      Opacity: "透明度",
      Shadow: "阴影",
      Text: "文本",
      "Text Background": "文本背景",
      Track: "轨道",
      Unmute: "取消静音",
    },
  ],
  [
    ["zh-tw", "zh-Hant"],
    {
      Play: "播放",
      Pause: "暫停",
      "Enter Fullscreen": "進入全螢幕",
      "Exit Fullscreen": "退出全螢幕",
      "Enter PiP": "進入畫中畫",
      "Exit PiP": "退出畫中畫",
      "Closed-Captions On": "開啟字幕",
      "Closed-Captions Off": "關閉字幕",
      Mute: "靜音",
      Volume: "音量",
      "Seek Forward": "快進",
      "Seek Backward": "快退",
      Announcements: "公告",
      Accessibility: "無障礙",
      Audio: "音頻",
      Auto: "自動",
      Boost: "增強",
      Captions: "字幕",
      "Caption Styles": "字幕樣式",
      "Captions look like this": "字幕樣式",
      Chapters: "章節",
      Connected: "已連接",
      Continue: "繼續",
      Connecting: "連接中",
      Default: "默認",
      Disabled: "已禁用",
      Disconnected: "已斷開連接",
      "Display Background": "顯示背景",
      Download: "下載",
      Font: "字體",
      Family: "字體",
      Fullscreen: "全螢幕",
      "Keyboard Animations": "鍵盤動畫",
      LIVE: "直播",
      Loop: "循環",
      Normal: "正常",
      Off: "關閉",
      Playback: "播放",
      PiP: "畫中畫",
      Quality: "畫質",
      Replay: "重播",
      Reset: "重置",
      Seek: "搜索",
      Settings: "設置",
      "Skip To Live": "跳轉到直播",
      Speed: "速度",
      Size: "大小",
      Color: "顏色",
      Opacity: "透明度",
      Shadow: "陰影",
      Text: "文本",
      "Text Background": "文本背景",
      Track: "軌道",
      Unmute: "取消靜音",
    },
  ],
  [
    ["de"],
    {
      Play: "Wiedergabe",
      Pause: "Pause",
      "Enter Fullscreen": "Vollbildmodus aktivieren",
      "Exit Fullscreen": "Vollbildmodus beenden",
      "Enter PiP": "Bild-in-Bild-Modus aktivieren",
      "Exit PiP": "Bild-in-Bild-Modus beenden",
      "Closed-Captions On": "Untertitel einblenden",
      "Closed-Captions Off": "Untertitel ausblenden",
      Mute: "Stummschalten",
      Volume: "Lautstärke",
      "Seek Forward": "Vorspulen",
      "Seek Backward": "Zurückspulen",
      Announcements: "Ankündigungen",
      Accessibility: "Barrierefreiheit",
      Audio: "Audio",
      Auto: "Automatisch",
      Boost: "Boost",
      Captions: "Untertitel",
      "Caption Styles": "Untertitel-Stile",
      "Captions look like this": "Untertitel-Stile",
      Chapters: "Kapitel",
      Connected: "Verbunden",
      Continue: "Weiter",
      Connecting: "Verbinden",
      Default: "Standard",
      Disabled: "Deaktiviert",
      Disconnected: "Getrennt",
      "Display Background": "Hintergrund anzeigen",
      Download: "Herunterladen",
      Font: "Schriftart",
      Family: "Schriftfamilie",
      Fullscreen: "Vollbild",
      "Keyboard Animations": "Tastaturanimationen",
      LIVE: "LIVE",
      Loop: "Wiederholen",
      Normal: "Normal",
      Off: "Aus",
      Playback: "Wiedergabe",
      PiP: "Bild-in-Bild",
      Quality: "Qualität",
      Replay: "Wiederholen",
      Reset: "Zurücksetzen",
      Seek: "Suchen",
      Settings: "Einstellungen",
      "Skip To Live": "Zum Live-Modus wechseln",
      Speed: "Geschwindigkeit",
      Size: "Größe",
      Color: "Farbe",
      Opacity: "Deckkraft",
      Shadow: "Schatten",
      Text: "Text",
      "Text Background": "Text-Hintergrund",
      Track: "Spur",
      Unmute: "Ton einschalten",
    },
  ],
  [
    ["vi"],
    {
      Play: "Phát",
      Pause: "Tạm dừng",
      "Enter Fullscreen": "Mở toàn màn hình",
      "Exit Fullscreen": "Thoát toàn màn hình",
      "Enter PiP": "Vào chế độ hình trong hình",
      "Exit PiP": "Thoát chế độ hình trong hình",
      "Closed-Captions On": "Bật phụ đề",
      "Closed-Captions Off": "Tắt phụ đề",
      Mute: "Tắt tiếng",
      Volume: "Âm lượng",
      "Seek Forward": "Chuyển tiến",
      "Seek Backward": "Chuyển lùi",
      Announcements: "Thông báo",
      Accessibility: "Truy cập",
      Audio: "Âm thanh",
      Auto: "Tự động",
      Boost: "Tăng cường",
      Captions: "Phụ đề",
      "Caption Styles": "Kiểu phụ đề",
      "Captions look like this": "Kiểu phụ đề",
      Chapters: "Chương",
      Connected: "Đã kết nối",
      Continue: "Tiếp tục",
      Connecting: "Đang kết nối",
      Default: "Mặc định",
      Disabled: "Đã tắt",
      Disconnected: "Đã ngắt kết nối",
      "Display Background": "Hiển thị nền",
      Download: "Tải xuống",
      Font: "Phông chữ",
      Family: "Phông chữ",
      Fullscreen: "Toàn màn hình",
      "Keyboard Animations": "Hiệu ứng bàn phím",
      LIVE: "TRỰC TIẾP",
      Loop: "Lặp lại",
      Normal: "Bình thường",
      Off: "Tắt",
      Playback: "Phát",
      PiP: "Hình trong hình",
      Quality: "Chất lượng",
      Replay: "Phát lại",
      Reset: "Đặt lại",
      Seek: "Tìm kiếm",
      Settings: "Cài đặt",
      "Skip To Live": "Chuyển đến trực tiếp",
      Speed: "Tốc độ",
      Size: "Kích thước",
      Color: "Màu sắc",
      Opacity: "Độ mờ",
      Shadow: "Bóng",
      Text: "Văn bản",
      "Text Background": "Nền văn bản",
      Track: "Dấu vết",
      Unmute: "Bật tiếng",
    },
  ],
  [
    ["uk"],
    {
      Play: "Відтворити",
      Pause: "Пауза",
      "Enter Fullscreen": "Увійти в повноекранний режим",
      "Exit Fullscreen": "Вийти з повноекранного режиму",
      "Enter PiP": "Увійти в режим картинка-в-картинці",
      "Exit PiP": "Вийти з режиму картинка-в-картинці",
      "Closed-Captions On": "Увімкнути субтитри",
      "Closed-Captions Off": "Вимкнути субтитри",
      Mute: "Вимкнути звук",
      Volume: "Гучність",
      "Seek Forward": "Прискорити",
      "Seek Backward": "Прокрутити назад",
      Announcements: "Оголошення",
      Accessibility: "Доступність",
      Audio: "Аудіо",
      Auto: "Автоматично",
      Boost: "Підвищити",
      Captions: "Субтитри",
      "Caption Styles": "Стилі субтитрів",
      "Captions look like this": "Стилі субтитрів",
      Chapters: "Розділи",
      Connected: "Підключено",
      Continue: "Продовжити",
      Connecting: "Підключення",
      Default: "За замовчуванням",
      Disabled: "Вимкнено",
      Disconnected: "Відключено",
      "Display Background": "Показати фон",
      Download: "Завантажити",
      Font: "Шрифт",
      Family: "Сімейство шрифтів",
      Fullscreen: "Повноекранний режим",
      "Keyboard Animations": "Анімація клавіатури",
      LIVE: "Наживо",
      Loop: "Повторювати",
      Normal: "Звичайний",
      Off: "Вимкнено",
      Playback: "Відтворення",
      PiP: "Картинка-в-картинці",
      Quality: "Якість",
      Replay: "Повторити",
      Reset: "Скинути",
      Seek: "Пошук",
      Settings: "Налаштування",
      "Skip To Live": "Перейти до прямого ефіру",
      Speed: "Швидкість",
      Size: "Розмір",
      Color: "Колір",
      Opacity: "Непрозорість",
      Shadow: "Тінь",
      Text: "Текст",
      "Text Background": "Фон тексту",
      Track: "Трек",
      Unmute: "Увімкнути звук",
    },
  ],
  [
    ["ru"],
    {
      Play: "Воспроизвести",
      Pause: "Пауза",
      "Enter Fullscreen": "Войти в полноэкранный режим",
      "Exit Fullscreen": "Выйти из полноэкранного режима",
      "Enter PiP": "Войти в режим картинка в картинке",
      "Exit PiP": "Выйти из режима картинка в картинке",
      "Closed-Captions On": "Включить субтитры",
      "Closed-Captions Off": "Выключить субтитры",
      Mute: "Выключить звук",
      Volume: "Громкость",
      "Seek Forward": "Ускорить",
      "Seek Backward": "Прокрутить назад",
      Announcements: "Объявления",
      Accessibility: "Доступность",
      Audio: "Аудио",
      Auto: "Автоматически",
      Boost: "Усилить",
      Captions: "Субтитры",
      "Caption Styles": "Стили субтитров",
      "Captions look like this": "Стили субтитров",
      Chapters: "Главы",
      Connected: "Подключено",
      Continue: "Продолжить",
      Connecting: "Подключение",
      Default: "По умолчанию",
      Disabled: "Отключено",
      Disconnected: "Отключено",
      "Display Background": "Показать фон",
      Download: "Скачать",
      Font: "Шрифт",
      Family: "Семейство шрифтов",
      Fullscreen: "Полноэкранный режим",
      "Keyboard Animations": "Анимации клавиатуры",
      LIVE: "В прямом эфире",
      Loop: "Повторять",
      Normal: "Обычный",
      Off: "Отключено",
      Playback: "Воспроизведение",
      PiP: "Картинка в картинке",
      Quality: "Качество",
      Replay: "Повторить",
      Reset: "Сбросить",
      Seek: "Поиск",
      Settings: "Настройки",
      "Skip To Live": "Перейти к прямому эфиру",
      Speed: "Скорость",
      Size: "Размер",
      Color: "Цвет",
      Opacity: "Непрозрачность",
      Shadow: "Тень",
      Text: "Текст",
      "Text Background": "Фон текста",
      Track: "Трек",
      Unmute: "Включить звук",
    },
  ],
  [
    ["br"],
    {
      Play: "Reproduzir",
      Pause: "Pausar",
      "Enter Fullscreen": "Entrar em tela cheia",
      "Exit Fullscreen": "Sair da tela cheia",
      "Enter PiP": "Entrar em PiP",
      "Exit PiP": "Sair de PiP",
      "Closed-Captions On": "Ativar legendas",
      "Closed-Captions Off": "Desativar legendas",
      Mute: "Mudo",
      Volume: "Volume",
      "Seek Forward": "Avançar",
      "Seek Backward": "Retroceder",
      Announcements: "Anúncios",
      Accessibility: "Acessibilidade",
      Audio: "Áudio",
      Auto: "Automático",
      Boost: "Aumentar",
      Captions: "Legendas",
      "Caption Styles": "Estilos de legenda",
      "Captions look like this": "Estilos de legenda",
      Chapters: "Capítulos",
      Connected: "Conectado",
      Continue: "Continuar",
      Connecting: "Conectando",
      Default: "Padrão",
      Disabled: "Desativado",
      Disconnected: "Desconectado",
      "Display Background": "Mostrar fundo",
      Download: "Baixar",
      Font: "Fonte",
      Family: "Família",
      Fullscreen: "Tela cheia",
      "Keyboard Animations": "Animações do teclado",
      LIVE: "AO VIVO",
      Loop: "Repetir",
      Normal: "Normal",
      Off: "Desligado",
      Playback: "Reprodução",
      PiP: "PiP",
      Quality: "Qualidade",
      Replay: "Repetir",
      Reset: "Redefinir",
      Seek: "Buscar",
      Settings: "Configurações",
      "Skip To Live": "Pular para ao vivo",
      Speed: "Velocidade",
      Size: "Tamanho",
      Color: "Cor",
      Opacity: "Opacidade",
      Shadow: "Sombra",
      Text: "Texto",
      "Text Background": "Fundo do texto",
      Track: "Trilha",
      Unmute: "Ativar som",
    },
  ],
  [
    ["p"],
    {
      Play: "Odtwórz",
      Pause: "Pauza",
      "Enter Fullscreen": "Wejdź na pełny ekran",
      "Exit Fullscreen": "Wyjdź z pełnego ekranu",
      "Enter PiP": "Wejdź w tryb obraz w obrazie",
      "Exit PiP": "Wyjdź z trybu obraz w obrazie",
      "Closed-Captions On": "Włącz napisy",
      "Closed-Captions Off": "Wyłącz napisy",
      Mute: "Wycisz",
      Volume: "Głośność",
      "Seek Forward": "Przewiń do przodu",
      "Seek Backward": "Przewiń do tyłu",
      Announcements: "Ogłoszenia",
      Accessibility: "Dostępność",
      Audio: "Audio",
      Auto: "Automatycznie",
      Boost: "Wzmocnij",
      Captions: "Napisy",
      "Caption Styles": "Style napisów",
      "Captions look like this": "Style napisów",
      Chapters: "Rozdziały",
      Connected: "Połączono",
      Continue: "Kontynuuj",
      Connecting: "Łączenie",
      Default: "Domyślne",
      Disabled: "Wyłączone",
      Disconnected: "Rozłączono",
      "Display Background": "Pokaż tło",
      Download: "Pobierz",
      Font: "Czcionka",
      Family: "Rodzina",
      Fullscreen: "Pełny ekran",
      "Keyboard Animations": "Animacje klawiatury",
      LIVE: "NA ŻYWO",
      Loop: "Pętla",
      Normal: "Normalny",
      Off: "Wyłącz",
      Playback: "Odtwarzanie",
      PiP: "Obraz w obrazie",
      Quality: "Jakość",
      Replay: "Powtórz",
      Reset: "Resetuj",
      Seek: "Szukaj",
      Settings: "Ustawienia",
      "Skip To Live": "Przejdź na żywo",
      Speed: "Prędkość",
      Size: "Rozmiar",
      Color: "Kolor",
      Opacity: "Przezroczystość",
      Shadow: "Cień",
      Text: "Tekst",
      "Text Background": "Tło tekstu",
      Track: "Ścieżka",
      Unmute: "Włącz dźwięk",
    },
  ],
  [
    ["sk"],
    {
      Play: "Prehrať",
      Pause: "Pauza",
      "Enter Fullscreen": "Prepnúť na celú obrazovku",
      "Exit Fullscreen": "Opustiť celú obrazovku",
      "Enter PiP": "Prepnúť na obraz v obraze",
      "Exit PiP": "Opustiť obraz v obraze",
      "Closed-Captions On": "Zapnúť titulky",
      "Closed-Captions Off": "Vypnúť titulky",
      Mute: "Ztlmiť",
      Volume: "Hlasitosť",
      "Seek Forward": "Posunúť vpred",
      "Seek Backward": "Posunúť vzad",
      Announcements: "Oznámenia",
      Accessibility: "Prístupnosť",
      Audio: "Audio",
      Auto: "Automaticky",
      Boost: "Zvýšiť",
      Captions: "Titulky",
      "Caption Styles": "Štýly titulkov",
      "Captions look like this": "Štýly titulkov",
      Chapters: "Kapitoly",
      Connected: "Pripojené",
      Continue: "Pokračovať",
      Connecting: "Pripájanie",
      Default: "Predvolené",
      Disabled: "Zakázané",
      Disconnected: "Odpojené",
      "Display Background": "Zobraziť pozadie",
      Download: "Stiahnuť",
      Font: "Písmo",
      Family: "Rodina",
      Fullscreen: "Celá obrazovka",
      "Keyboard Animations": "Klávesové animácie",
      LIVE: "ŽIVÉ",
      Loop: "Opakovať",
      Normal: "Normálne",
      Off: "Vypnuté",
      Playback: "Prehrávanie",
      PiP: "Obraz v obraze",
      Quality: "Kvalita",
      Replay: "Zopakovať",
      Reset: "Obnoviť",
      Seek: "Hľadať",
      Settings: "Nastavenia",
      "Skip To Live": "Preskočiť na živý prenos",
      Speed: "Rýchlosť",
      Size: "Veľkosť",
      Color: "Farba",
      Opacity: "Priehľadnosť",
      Shadow: "Tieň",
      Text: "Text",
      "Text Background": "Pozadie textu",
      Track: "Stopa",
      Unmute: "Zapnúť zvuk",
    },
  ],
  [
    ["fr"],
    {
      Play: "Lecture",
      Pause: "Pause",
      "Enter Fullscreen": "Passer en plein écran",
      "Exit Fullscreen": "Quitter le plein écran",
      "Enter PiP": "Passer en mode image dans l'image",
      "Exit PiP": "Quitter le mode image dans l'image",
      "Closed-Captions On": "Activer les sous-titres",
      "Closed-Captions Off": "Désactiver les sous-titres",
      Mute: "Muet",
      Volume: "Volume",
      "Seek Forward": "Avancer",
      "Seek Backward": "Reculer",
      Announcements: "Annonces",
      Accessibility: "Accessibilité",
      Audio: "Audio",
      Auto: "Automatique",
      Boost: "Amplifier",
      Captions: "Sous-titres",
      "Caption Styles": "Styles de sous-titres",
      "Captions look like this": "Styles de sous-titres",
      Chapters: "Chapitres",
      Connected: "Connecté",
      Continue: "Continuer",
      Connecting: "Connexion",
      Default: "Par défaut",
      Disabled: "Désactivé",
      Disconnected: "Déconnecté",
      "Display Background": "Afficher l'arrière-plan",
      Download: "Télécharger",
      Font: "Police",
      Family: "Famille",
      Fullscreen: "Plein écran",
      "Keyboard Animations": "Animations du clavier",
      LIVE: "EN DIRECT",
      Loop: "Boucle",
      Normal: "Normal",
      Off: "Désactivé",
      Playback: "Lecture",
      PiP: "Image dans l'image",
      Quality: "Qualité",
      Replay: "Rejouer",
      Reset: "Réinitialiser",
      Seek: "Rechercher",
      Settings: "Paramètres",
      "Skip To Live": "Aller en direct",
      Speed: "Vitesse",
      Size: "Taille",
      Color: "Couleur",
      Opacity: "Opacité",
      Shadow: "Ombre",
      Text: "Texte",
      "Text Background": "Arrière-plan du texte",
      Track: "Piste",
      Unmute: "Activer le son",
    },
  ],
  [
    ["es"],
    {
      Play: "Reproducir",
      Pause: "Pausa",
      "Enter Fullscreen": "Entrar en pantalla completa",
      "Exit Fullscreen": "Salir de pantalla completa",
      "Enter PiP": "Entrar en modo imagen en imagen",
      "Exit PiP": "Salir de modo imagen en imagen",
      "Closed-Captions On": "Activar subtítulos",
      "Closed-Captions Off": "Desactivar subtítulos",
      Mute: "Silenciar",
      Volume: "Volumen",
      "Seek Forward": "Avanzar",
      "Seek Backward": "Retroceder",
      Announcements: "Anuncios",
      Accessibility: "Accesibilidad",
      Audio: "Audio",
      Auto: "Automático",
      Boost: "Aumentar",
      Captions: "Subtítulos",
      "Caption Styles": "Estilos de subtítulos",
      "Captions look like this": "Estilos de subtítulos",
      Chapters: "Capítulos",
      Connected: "Conectado",
      Continue: "Continuar",
      Connecting: "Conectando",
      Default: "Predeterminado",
      Disabled: "Desactivado",
      Disconnected: "Desconectado",
      "Display Background": "Mostrar fondo",
      Download: "Descargar",
      Font: "Fuente",
      Family: "Familia",
      Fullscreen: "Pantalla completa",
      "Keyboard Animations": "Animaciones de teclado",
      LIVE: "EN DIRECTO",
      Loop: "Repetir",
      Normal: "Normal",
      Off: "Desactivado",
      Playback: "Reproducción",
      PiP: "Imagen en imagen",
      Quality: "Calidad",
      Replay: "Repetir",
      Reset: "Restablecer",
      Seek: "Buscar",
      Settings: "Configuración",
      "Skip To Live": "Ir en directo",
      Speed: "Velocidad",
      Size: "Tamaño",
      Color: "Color",
      Opacity: "Opacidad",
      Shadow: "Sombra",
      Text: "Texto",
      "Text Background": "Fondo de texto",
      Track: "Pista",
      Unmute: "Activar sonido",
    },
  ],
  [
    ["ja"],
    {
      Play: "再生",
      Pause: "一時停止",
      "Enter Fullscreen": "フルスクリーンに入る",
      "Exit Fullscreen": "フルスクリーンを終了",
      "Enter PiP": "PiPモードに入る",
      "Exit PiP": "PiPモードを終了",
      "Closed-Captions On": "字幕をオンにする",
      "Closed-Captions Off": "字幕をオフにする",
      Mute: "ミュート",
      Volume: "音量",
      "Seek Forward": "早送り",
      "Seek Backward": "巻き戻し",
      Announcements: "お知らせ",
      Accessibility: "アクセシビリティ",
      Audio: "オーディオ",
      Auto: "自動",
      Boost: "ブースト",
      Captions: "字幕",
      "Caption Styles": "字幕スタイル",
      "Captions look like this": "字幕スタイル",
      Chapters: "チャプター",
      Connected: "接続済み",
      Continue: "続行",
      Connecting: "接続中",
      Default: "デフォルト",
      Disabled: "無効",
      Disconnected: "切断済み",
      "Display Background": "背景を表示",
      Download: "ダウンロード",
      Font: "フォント",
      Family: "ファミリー",
      Fullscreen: "フルスクリーン",
      "Keyboard Animations": "キーボードアニメーション",
      LIVE: "ライブ",
      Loop: "ループ",
      Normal: "通常",
      Off: "オフ",
      Playback: "再生",
      PiP: "PiP",
      Quality: "画質",
      Replay: "リプレイ",
      Reset: "リセット",
      Seek: "検索",
      Settings: "設定",
      "Skip To Live": "ライブにスキップ",
      Speed: "速度",
      Size: "サイズ",
      Color: "色",
      Opacity: "不透明度",
      Shadow: "影",
      Text: "テキスト",
      "Text Background": "テキストの背景",
      Track: "トラック",
      Unmute: "ミュート解除",
    },
  ],
  [
    ["tr"],
    {
      Play: "Oynat",
      Pause: "Duraklat",
      "Enter Fullscreen": "Tam Ekrana Gir",
      "Exit Fullscreen": "Tam Ekrandan Çık",
      "Enter PiP": "PiP'ye Gir",
      "Exit PiP": "PiP'den Çık",
      "Closed-Captions On": "Altyazıları Aç",
      "Closed-Captions Off": "Altyazıları Kapat",
      Mute: "Sessiz",
      Volume: "Ses",
      "Seek Forward": "İleri Sar",
      "Seek Backward": "Geri Sar",
      Announcements: "Duyurular",
      Accessibility: "Erişilebilirlik",
      Audio: "Ses",
      Auto: "Otomatik",
      Boost: "Artır",
      Captions: "Altyazılar",
      "Caption Styles": "Altyazı Stilleri",
      "Captions look like this": "Altyazı Stilleri",
      Chapters: "Bölümler",
      Connected: "Bağlı",
      Continue: "Devam",
      Connecting: "Bağlanıyor",
      Default: "Varsayılan",
      Disabled: "Devre Dışı",
      Disconnected: "Bağlantı Kesildi",
      "Display Background": "Arka Planı Göster",
      Download: "İndir",
      Font: "Yazı Tipi",
      Family: "Aile",
      Fullscreen: "Tam Ekran",
      "Keyboard Animations": "Klavye Animasyonları",
      LIVE: "CANLI",
      Loop: "Döngü",
      Normal: "Normal",
      Off: "Kapalı",
      Playback: "Oynatma",
      PiP: "PiP",
      Quality: "Kalite",
      Replay: "Tekrar Oynat",
      Reset: "Sıfırla",
      Seek: "Ara",
      Settings: "Ayarlar",
      "Skip To Live": "Canlıya Geç",
      Speed: "Hız",
      Size: "Boyut",
      Color: "Renk",
      Opacity: "Opaklık",
      Shadow: "Gölge",
      Text: "Metin",
      "Text Background": "Metin Arka Planı",
      Track: "Parça",
      Unmute: "Sesi Aç",
    },
  ],
  [
    ["ko"],
    {
      Play: "재생",
      Pause: "일시정지",
      "Enter Fullscreen": "전체화면으로 들어가기",
      "Exit Fullscreen": "전체화면에서 나가기",
      "Enter PiP": "PiP 모드로 들어가기",
      "Exit PiP": "PiP 모드에서 나가기",
      "Closed-Captions On": "자막 켜기",
      "Closed-Captions Off": "자막 끄기",
      Mute: "음소거",
      Volume: "볼륨",
      "Seek Forward": "앞으로 이동",
      "Seek Backward": "뒤로 이동",
      Announcements: "공지",
      Accessibility: "접근성",
      Audio: "오디오",
      Auto: "자동",
      Boost: "부스트",
      Captions: "자막",
      "Caption Styles": "자막 스타일",
      "Captions look like this": "자막 스타일",
      Chapters: "챕터",
      Connected: "연결됨",
      Continue: "계속",
      Connecting: "연결 중",
      Default: "기본값",
      Disabled: "비활성화됨",
      Disconnected: "연결 끊김",
      "Display Background": "배경 표시",
      Download: "다운로드",
      Font: "글꼴",
      Family: "가족",
      Fullscreen: "전체화면",
      "Keyboard Animations": "키보드 애니메이션",
      LIVE: "실시간",
      Loop: "반복",
      Normal: "보통",
      Off: "끔",
      Playback: "재생",
      Quality: "품질",
      Replay: "다시 보기",
      Reset: "재설정",
      Seek: "검색",
      Settings: "설정",
      "Skip To Live": "실시간으로 이동",
      Speed: "속도",
      Size: "크기",
      Color: "색상",
      Opacity: "불투명도",
      Shadow: "그림자",
      Text: "텍스트",
      "Text Background": "텍스트 배경",
      Track: "트랙",
      Unmute: "음소거 해제",
    },
  ],
  [
    ["fi"],
    {
      Play: "Toista",
      Pause: "Tauko",
      "Enter Fullscreen": "Siirry koko näytölle",
      "Exit Fullscreen": "Poistu koko näytöltä",
      "Enter PiP": "Siirry kuva kuvassa -tilaan",
      "Exit PiP": "Poistu kuva kuvassa -tilasta",
      "Closed-Captions On": "Ota tekstitykset käyttöön",
      "Closed-Captions Off": "Poista tekstitykset käytöstä",
      Mute: "Mykistä",
      Volume: "Äänenvoimakkuus",
      "Seek Forward": "Siirry eteenpäin",
      "Seek Backward": "Siirry taaksepäin",
      Announcements: "Ilmoitukset",
      Accessibility: "Saavutettavuus",
      Audio: "Ääni",
      Auto: "Automaattinen",
      Boost: "Tehosta",
      Captions: "Tekstitykset",
      "Caption Styles": "Tekstitystyyli",
      "Captions look like this": "Tekstitystyyli",
      Chapters: "Luvut",
      Connected: "Yhdistetty",
      Continue: "Jatka",
      Connecting: "Yhdistetään",
      Default: "Oletus",
      Disabled: "Poistettu käytöstä",
      Disconnected: "Yhteys katkaistu",
      "Display Background": "Näytä tausta",
      Download: "Lataa",
      Font: "Fontti",
      Family: "Perhe",
      Fullscreen: "Koko näyttö",
      "Keyboard Animations": "Näppäin animaatiot",
      LIVE: "LIVE",
      Loop: "Toista uudelleen",
      Normal: "Normaali",
      Off: "Pois",
      Playback: "Toisto",
      PiP: "Kuva kuvassa",
      Quality: "Laatu",
      Replay: "Toista uudelleen",
      Reset: "Palauta",
      Seek: "Hae",
      Settings: "Asetukset",
      "Skip To Live": "Siirry suorana",
      Speed: "Nopeus",
      Size: "Koko",
      Color: "Väri",
      Opacity: "Sameus",
      Shadow: "Varjo",
      Text: "Teksti",
      "Text Background": "Tekstin tausta",
      Track: "Raita",
      Unmute: "Poista mykistys",
    },
  ],
  [
    ["hu"],
    {
      Play: "Lejátszás",
      Pause: "Szünet",
      "Enter Fullscreen": "Belépés a teljes képernyős módba",
      "Exit Fullscreen": "Kilépés a teljes képernyős módból",
      "Enter PiP": "Belépés a kép a képben módba",
      "Exit PiP": "Kilépés a kép a képben módból",
      "Closed-Captions On": "Feliratok bekapcsolása",
      "Closed-Captions Off": "Feliratok kikapcsolása",
      Mute: "Némítás",
      Volume: "Hangerő",
      "Seek Forward": "Előre ugrás",
      "Seek Backward": "Visszalépés",
      Announcements: "Hirdetések",
      Accessibility: "Hozzáférhetőség",
      Audio: "Hang",
      Auto: "Automatikus",
      Boost: "Felerősítés",
      Captions: "Feliratok",
      "Caption Styles": "Felirat stílusok",
      "Captions look like this": "Felirat stílusok",
      Chapters: "Fejezetek",
      Connected: "Csatlakoztatva",
      Continue: "Folytatás",
      Connecting: "Csatlakozás",
      Default: "Alapértelmezett",
      Disabled: "Letiltva",
      Disconnected: "Nincs kapcsolat",
      "Display Background": "Háttér megjelenítése",
      Download: "Letöltés",
      Font: "Betűtípus",
      Family: "Család",
      Fullscreen: "Teljes képernyő",
      "Keyboard Animations": "Billentyűzet animációk",
      LIVE: "ÉLŐ",
      Loop: "Ismétlés",
      Normal: "Normál",
      Off: "Kikapcsolva",
      Playback: "Lejátszás",
      PiP: "Kép a képben",
      Quality: "Minőség",
      Replay: "Ismétlés",
      Reset: "Visszaállítás",
      Seek: "Keresés",
      Settings: "Beállítások",
      "Skip To Live": "Ugrás az élő adásra",
      Speed: "Sebesség",
      Size: "Méret",
      Color: "Szín",
      Opacity: "Átlátszatlanság",
      Shadow: "Árnyék",
      Text: "Szöveg",
      "Text Background": "Szöveg háttér",
      Track: "Sáv",
      Unmute: "Némítás feloldása",
    },
  ],
  [
    ["id"],
    {
      Play: "Putar",
      Pause: "Jeda",
      "Enter Fullscreen": "Masuk ke Layar Penuh",
      "Exit Fullscreen": "Keluar dari Layar Penuh",
      "Enter PiP": "Masuk ke Mode PiP",
      "Exit PiP": "Keluar dari Mode PiP",
      "Closed-Captions On": "Nyalakan Teks",
      "Closed-Captions Off": "Matikan Teks",
      Mute: "Bisukan",
      Volume: "Volume",
      "Seek Forward": "Cari Maju",
      "Seek Backward": "Cari Mundur",
      Announcements: "Pengumuman",
      Accessibility: "Aksesibilitas",
      Audio: "Audio",
      Auto: "Otomatis",
      Boost: "Tingkatkan",
      Captions: "Teks",
      "Caption Styles": "Gaya Teks",
      "Captions look like this": "Gaya Teks",
      Chapters: "Bab",
      Connected: "Terhubung",
      Continue: "Lanjutkan",
      Connecting: "Menghubungkan",
      Default: "Default",
      Disabled: "Nonaktif",
      Disconnected: "Terputus",
      "Display Background": "Tampilkan Latar Belakang",
      Download: "Unduh",
      Font: "Font",
      Family: "Keluarga",
      Fullscreen: "Layar Penuh",
      "Keyboard Animations": "Animasi Keyboard",
      LIVE: "LANGSUNG",
      Loop: "Ulang",
      Normal: "Normal",
      Off: "Mati",
      Playback: "Putar",
      PiP: "PiP",
      Quality: "Kualitas",
      Replay: "Putar Ulang",
      Reset: "Atur Ulang",
      Seek: "Cari",
      Settings: "Pengaturan",
      "Skip To Live": "Lewati ke Langsung",
      Speed: "Kecepatan",
      Size: "Ukuran",
      Color: "Warna",
      Opacity: "Ketidakjelasan",
      Shadow: "Bayangan",
      Text: "Teks",
      "Text Background": "Latar Belakang Teks",
      Track: "Lacak",
      Unmute: "Bunyikan",
    },
  ],
  [
    ["nl"],
    {
      Play: "Afspelen",
      Pause: "Pauze",
      "Enter Fullscreen": "Volledig scherm",
      "Exit Fullscreen": "Verlaat volledig scherm",
      "Enter PiP": "Beeld-in-beeld",
      "Exit PiP": "Verlaat beeld-in-beeld",
      "Closed-Captions On": "Ondertiteling aan",
      "Closed-Captions Off": "Ondertiteling uit",
      Mute: "Geluid uit",
      Volume: "Volume",
      "Seek Forward": "Vooruit spoelen",
      "Seek Backward": "Achteruit spoelen",
      Announcements: "Mededelingen",
      Accessibility: "Toegankelijkheid",
      Audio: "Audio",
      Auto: "Automatisch",
      Boost: "Versterken",
      Captions: "Ondertiteling",
      "Caption Styles": "Ondertitelstijlen",
      "Captions look like this": "Ondertitelstijlen",
      Chapters: "Hoofdstukken",
      Connected: "Verbonden",
      Continue: "Doorgaan",
      Connecting: "Verbinden",
      Default: "Standaard",
      Disabled: "Uitgeschakeld",
      Disconnected: "Verbroken",
      "Display Background": "Achtergrond weergeven",
      Download: "Downloaden",
      Font: "Lettertype",
      Family: "Familie",
      Fullscreen: "Volledig scherm",
      "Keyboard Animations": "Toetsenbordanimaties",
      LIVE: "LIVE",
      Loop: "Herhalen",
      Normal: "Normaal",
      Off: "Uit",
      Playback: "Afspelen",
      PiP: "Beeld-in-beeld",
      Quality: "Kwaliteit",
      Replay: "Opnieuw afspelen",
      Reset: "Resetten",
      Seek: "Zoeken",
      Settings: "Instellingen",
      "Skip To Live": "Naar live gaan",
      Speed: "Snelheid",
      Size: "Grootte",
      Color: "Kleur",
      Opacity: "Dekking",
      Shadow: "Schaduw",
      Text: "Tekst",
      "Text Background": "Tekstachtergrond",
      Track: "Track",
      Unmute: "Geluid aan",
    },
  ],
];
